import React, { useEffect, useRef, useState } from 'react';
//import { Carousel } from 'primereact/carousel';
import { Button } from 'primereact/button';

import { Carousel } from '@trendyol-js/react-carousel';



const ExhibitionCarousel3 = (props) => {
    const itemWidth = 250;
    const itemHeight = 410;


    const ref = useRef(null);
    const [showCount, setShowCount] = useState(null);




    useEffect(() => {
        function handleResize() {
            let _show = ref.current.offsetWidth / itemWidth;
            console.log("getShow size width", ref.current.offsetWidth, _show);
            setShowCount(_show);
        }
        window.addEventListener("resize", handleResize);
        handleResize();
        return () => window.removeEventListener("resize", handleResize);
    }, []);



    const carouselItemTemplate = (exhibition, isLast) => {
        console.log("carouselItemTemplate", exhibition, isLast);
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                margin: 10,
                backgroundImage: `url(${exhibition.image})`,
                backgroundRepeat: 'no-repeat',
                borderRadius: 20,
                backgroundSize: 'cover',
                backgroundPositionX: 'center',
                backgroundPositionY: 'center',


            }}>
                <div style={{

                    width: '100%',

                }}>

                    <div style={{

                        flexDirection: 'column', // inner items will be added vertically
                        flexGrow: 1,            // all the available vertical space will be occupied by it
                        justifyContent: 'space-between', // will create the gutter between body and footer
                        height: '100%',
                        minHeight: itemHeight,
                        display: 'flex',
                        background: 'linear-gradient(rgb(0,0,0,0), rgb(0, 0,0,0.7))',
                        borderRadius: 20,
                        padding: 10,

                    }}>


                        <div style={{
                            flexDirection: 'row',
                            display: 'flex',

                        }}
                        >
                            <div style={{
                                flexDirection: 'row',
                                display: 'flex',
                                background: 'rgba(255, 255, 255, 0.65)',
                                boxShadow: '0px 0px 20px rgba(0, 0, 0, 0.20)',
                                borderRadius: 20,
                                backdropFilter: 'blur(10px)',
                                padding: 5,
                                alignItems: 'center',

                            }}>
                                <img style={{ width: 25, height: 25, borderRadius: 30 }} src="https://via.placeholder.com/25x25" />
                                <div style={{ paddingLeft: 5, color: 'black', fontSize: 14, fontWeight: '400', wordWrap: 'break-word', textAlign: 'center' }}>  {exhibition.museum}</div>
                            </div>

                        </div>

                        <div style={{

                            color: '#ffffff',
                            textAlign: 'center',
                            display: 'flex',
                            justifyContent: 'flex-end',
                            flexDirection: 'column', // inner items will be added vertically
                            flexGrow: 1,            // all the available vertical space will be occupied by it


                        }}>
                            <div style={{
                                height: '40%',

                                justifyContent: 'center',
                                display: 'flex',
                                alignItems: 'center',
                                flexDirection: 'column', // inner items will be added vertically

                            }}>
                                {exhibition.owner &&
                                    <div style={{
                                        fontSize: 16,
                                        color: '#ffffff',
                                        padding: 10,

                                        textAlign: 'center',

                                    }} >
                                        {exhibition.owner}
                                    </div>
                                }
                                <div className="question" style={{
                                    fontSize: 24,
                                    color: '#ffffff',
                                    padding: 10,

                                    textAlign: 'center',

                                }} >
                                    {exhibition.label}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    };

    const renderCarosel = () => {
        if (!showCount) {
            return <></>
        }


        return (
           
                <Carousel show={showCount} slide={1} swiping={true} hideArrows={false} infinite={false}>
                    {
                        props.data.map((param, index) => {
                            //
                            return (
                                <div key={index} style={{ width: itemWidth, height: itemHeight }}>
                                    {carouselItemTemplate(param, (param.length - 1) == index)}

                                </div>
                            )
                        })
                    }
                </Carousel>
        );
    }


    return (
        <div ref={ref}>
            {renderCarosel()
            }
        </div>
    );
};

export default ExhibitionCarousel3;

